import styled from 'styled-components';

export const Content = styled.div`
  height: 100vh;
  //justify-content: center;
  //display: flex;
  //flex-direction: column;
  //align-items: center;
  padding: 56px;

  .arrow-back {
    display: none;
  }

  @media (max-width: 768px) {
    padding: 56px 26px;
    .arrow-back {
      display: block;
      position: absolute;
      top: 15px;
      left: 10px;
      color: black;
    }
  }
`;

export const Container = styled.div`
  text-align: center;
  max-width: 560px;
  margin: auto;
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  z-index: 99;
  position: relative;

  > img {
    width: 128px;
  }

  h1 {
    font-size: 2rem;
    padding-bottom: 1rem;
    font-family: Arial, sans-serif;
    font-weight: 700;
    color: #000000;
  }

  h2 {
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 0;
    text-align: center;
    margin-bottom: 40px;
    display: flex;
    justify-content: center;

    .tooltip-container {
      margin-left: 10px;
    }
  }

  @media (max-width: 768px) {
    top: 2.5rem;

    h1 {
      font-size: 1.5rem;
    }

    > img {
      width: 98px;
    }
  }
`;

export const BackgroundImageBottom = styled.div`
  background-image: url('./img/register_backbottom.png');
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 300px;
  z-index: -1;

  @media (max-width: 580px) {
    width: 45vw;
  }
`;

export const BackgroundImageTop = styled.div`
  background-image: url('./img/register_backtop.png');
  background-position: right;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 300px;
  z-index: -1;

  @media (max-width: 580px) {
    height: 45vw;
  }
`;

export const Logo = styled.img`
  width: 128px;
  margin-bottom: 4rem;
`;

export const ActionIcon = styled.img`
  width: 60px;
  height: 60px;
  margin-bottom: 40px;
`;
